import * as React from 'react';
import {collection, doc, getDoc, limit, onSnapshot, orderBy, query, startAfter, where} from "firebase/firestore";
import {DB} from "../../../../config/firebase/firebase";
import {Avatar, Button, Portal, Skeleton, Stack, Typography} from "@mui/material";
import ProposalRequestDialog from "./proposal-request-dialog";
import {AuthUserContext} from "../../../../providers/auth-provider";


export default function RequestUserAvatarPic({request}){
  const {profile} = React.useContext(AuthUserContext);
  
  const [user, setUser] = React?.useState();
  const [loading, setLoading] = React?.useState(false);
  const [open, setOpen] = React?.useState(false); 
  const [applied, setApplied] = React?.useState(false);
  const [counts, setCounts] = React?.useState(0);
  React.useEffect(() => {
    setLoading(true)
    const userRef = doc(DB, "users", request?.uid);
    getDoc(userRef).then((doc) => {
      setUser(doc?.data())
      setLoading(false)
  
    });
  }, [request?.id])
  React.useEffect(() => {
    setLoading(true)
   const q =  query(
      collection(DB, "applicants"),
      where('requestId', '==', request?.id),
      orderBy("createdAt", "desc")
    )
    let unsub ;
    unsub = onSnapshot(
      q,
      (snapshot)=> {
        setCounts(snapshot?.size)
        snapshot.forEach(
          (doc) => {
            doc?.data()?.applicantUid === profile?.uid && setApplied(true)
          }
        )
      });
    return () => unsub
  }, [request?.id])
  return(
    <React.Fragment>
      {!loading ? <Stack direction={"row"} spacing={1} width={150} justifyContent="start"
                         alignItems="center" style={{marginBottom:"12px"}}>
        <Avatar aria-label={user?.displayName} src={user?.photoURL} sx={{width:43, height:43}}>
          <Typography variant={"h5"}>{user?.displayName?.charAt(0)}</Typography>
        </Avatar> 
         <Typography style={{fontSize:"16px"}} fontWeight={400} color={'#363636'} maxWidth={97} noWrap={true}>{user?.displayName}</Typography>
  
        {/* {request.uid !== profile?.uid && !applied &&       <Button variant={"contained"}  size={"small"} sx={{px: 2}} onClick={() => setOpen(!open)}>Apply now</Button>
        }
        { applied === true &&
          <Button variant={"contained"} color={"secondary"} size={"small"} sx={{px: 2}} onClick={() => setOpen(!open)} disabled>Applied</Button>
        } */}
        {/* <Typography variant={"caption"} color={'#8F8F8F'}>{counts > 0 && `${counts === 1 ? '1 applicant' : `Over ${counts} applicants`}`}</Typography> */}
      </Stack>
      :
        <Stack direction={"column"} spacing={.5} width={150}  justifyContent="flex-start"
               alignItems="center">
          <Skeleton variant={"circular"} height={51} width={51} />
          <Skeleton variant={'text'}/>
        </Stack>
      }
      
      {/* <Portal>
        {request && <ProposalRequestDialog request={request} open={open} cb={(bool) => setOpen(bool)} key={'applicant-' + request?.id}/>}
      </Portal> */}
      
    </React.Fragment>
  )
}